import { DatasetCartesian } from "@/modules/dataset-cartesian";
import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";
import { useInterventionSectionDatasetCartesian } from "@/modules/intervention/intervention-section-datasets";

const InterventionSectionCartesian = () => {
  const { key, loading, disabled, dataset, template } =
    useInterventionSectionDatasetCartesian();
  const { interventionAsset } = useInterventionSectionContext();

  return (
    <DatasetCartesian
      key={key}
      dataset={dataset}
      template={template}
      asset={interventionAsset}
      loading={loading}
      disabled={disabled}
    />
  );
};

export default InterventionSectionCartesian;
